import {
  StyleCard,
  StyleRowWrapper,
  StyleLeftWrapper,
  StyleRightWrapper,
} from './style'
import Skeleton from '@components/skeleton'
import Row from '@components/row'
const InstituteProviderCardLoader = () => {
  return (
    <StyleCard>
      <StyleRowWrapper>
        <StyleLeftWrapper>
          <Skeleton width={60} height={60} radius={30} />
        </StyleLeftWrapper>
        <StyleRightWrapper>
          <Skeleton width={100} radius={4} height={10} />
          <Row colGap={10}>
            <Skeleton width={45} height={25} radius={4} />
            <Skeleton width={45} height={25} radius={4} />
            <Skeleton width={45} height={25} radius={4} />
          </Row>
        </StyleRightWrapper>
      </StyleRowWrapper>
      <Row colGap={10} justifyContent="space-between">
        <Skeleton width={'49%'} height={35} radius={8} />
        <Skeleton width={'49%'} height={35} radius={8} />
      </Row>
    </StyleCard>
  )
}

export default InstituteProviderCardLoader
